import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerSite extends AManagerApi {
    protected _url: string = '/owner/site';
}
